import React, { useEffect, useState } from 'react'
import { useDispatch,useSelector } from 'react-redux';
import { setPermissions, unsetPermissions } from "../../../Redux/Actions/permission_action"
let SERVER_URL = process.env.REACT_APP_API_URL;
let BASE_URL = process.env.REACT_APP_APP_URL;
let token = JSON.parse(localStorage.getItem('key'));
function SubMenuOperationsCom({ submenu_id }) {
    const dispatch = useDispatch()
    const [operations, subOperations] = useState([])
    useEffect(() => {
        getSubMenuOperations(submenu_id)
    }, [submenu_id])
    const getSubMenuOperations = (submenu_id) => {
        fetch(SERVER_URL + `api/menu/get-sub-menu`, {
            method: 'post',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'authorization': `bearer ${token.value}`
            },
            body: JSON.stringify({
                menu_id: submenu_id
            })
        }).then(res => res.json()).then(data => {
            if (data.status == true) {
                subOperations(data.results)
            }
            // console.log(data.results)
        })
    }
    const[conn_opteration,setconn_opteration] = useState([])
    const HandleSubMenu = (value, checked) => {
        if (checked) {
            dispatch(setPermissions(value, checked))
        } else {
            dispatch(unsetPermissions(value, checked))
        }
    }
    let get_per = useSelector((state) => state)
    return (
        <>
            {
                operations?.map((item, ind) => {
                    return <div key={ind} className="col-md-4">
                        <div className="form-check formcheck1 mt00 mb05">
                            <input checked={get_per?.Permission?.permissions?.includes(item.menu_id?.toString())} className="form-check-input" type="checkbox" value={item.menu_id} onChange={(e) => HandleSubMenu(e.target.value, e.target.checked)} />
                            <label className="form-check-label" htmlFor="employee_leave">
                                {item.menu_name}
                            </label>
                        </div>
                    </div>
                })
            }
        </>
    )
}

export default SubMenuOperationsCom
